export interface ICloseAccount {
  userId: string;
  phoneNumber: string;
  code: string;
}
